import ResourcesModalForm from './ResourcesModalForm'
export default ResourcesModalForm
